import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RIFERIMENTI } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDolRiferimentiState extends EntityState<IID_OL_RIFERIMENTI, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_RIFERIMENTI })
export class IIDolRiferimentiStore extends EntityStore<IIDolRiferimentiState> {
  constructor() {
    super([]);
  }
}
